/* eslint-disable no-useless-constructor */
import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import AppId from "~/utils/partner";
import { createPartnerUser } from "~/store/partnerUser/actions";
import { MOMO } from "~utils/constants";
class PartnerRedirect extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    if (AppId === MOMO) {
      const paramsId = this.props.match.params.id;
      this.props.createPartnerUser(paramsId);
    }
  }

  render() {
    if (AppId !== MOMO) return <Redirect to="/" />;
    return <Redirect to="/chon-benh-vien" />;
  }
}

export default connect(null, { createPartnerUser })(PartnerRedirect);
